<template>
  <div class="goodsPaymentDetail">
    <Tab title="详情" />
    <div class="goods">
      <div class="showMoney">
        <p>变动金额</p>
        <p>+4989.00</p>
      </div>
      <div class="goodslist">
        <div class="goodsDetail">
          <img src alt />
          <div>
            <p class="goodsTitle">天然新疆和田玉帝王青玉南瓜手串</p>
            <span>规格一</span>
            <p class="money">¥498</p>
          </div>
          <span class="goodsNumber">x1</span>
        </div>
      </div>
    </div>
    <div class="info">
      <p>
        <span>交易号：</span>
        <span>7654338768757605</span>
      </p>
      <p>
        <span>交易时间：</span>
        <span>2020/06/12 10:07:10</span>
      </p>
      <p>
        <span>商户信息：</span>
        <span>店铺名称</span>
      </p>
    </div>
  </div>
</template>

<script>
import Tab from "base/tab/tab";
export default {
  data() {
    return {};
  },
  components: {
    Tab,
  },
};
</script>

<style lang="scss" scoped>
.goodsPaymentDetail {
  padding-top: 100px;
  width: 100%;
  height: 100%;
  background: #f6f7fb;
  .goods {
    .showMoney {
      height: 150px;
      padding: 0 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: linear-gradient(
        138deg,
        rgba(245, 117, 94, 1) 0%,
        rgba(232, 64, 49, 1) 100%
      );
      p {
        color: rgba(255, 255, 255, 1);
        &:nth-child(1) {
          height: 40px;
          font-size: 28px;
          line-height: 40px;
        }
        &:nth-child(2) {
          height: 53px;
          font-size: 46px;
          line-height: 53px;
          font-family: DINAlternate-Bold, DINAlternate;
        }
      }
    }
    .goodslist {
      background: #fff;
      margin-bottom: 20px;
      .goodsDetail {
        display: flex;
        padding: 27px 30px;
        img {
          width: 126px;
          height: 126px;
          display: block;
          background: #000;
          margin-right: 36px;
        }
        div {
          .goodsTitle {
            width: 490px;
            height: 32px;
            font-size: 28px;
            color: rgba(51, 51, 51, 1);
            line-height: 32px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span {
            display: block;
            margin: 7px 0 12px;
            height: 36px;
            font-size: 24px;
            color: rgba(153, 153, 153, 1);
            line-height: 36px;
          }
          .money {
            height: 36px;
            font-size: 32px;
            font-weight: 500;
            color: rgba(242, 70, 70, 1);
            line-height: 36px;
          }
        }
        .goodsNumber {
          margin: auto 0 0 0;
          height: 42px;
          font-size: 30px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
          line-height: 42px;
        }
      }
    }
  }
  .info {
    padding: 32px 30px 32px 34px;
    background: #fff;
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 37px;
      font-size: 26px;
      line-height: 37px;
      margin-bottom: 24px;
      span:nth-child(1) {
        color: rgba(153, 153, 153, 1);
      }
      span:nth-child(2) {
        color: rgba(51, 51, 51, 1);
      }
      &:last-child{
          margin-bottom: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/goodsPayment/detail.vue